import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import StyleguideSectionState from "@toolkit/Framework/Store/Toolkit/Components/Styleguide/StyleguideState";
import { StyleguideSectionModel } from "@toolkit/Framework/Store/Toolkit/Components/Styleguide/StyleguideTypes";
import { Draft } from "immer";

const initialState: StyleguideSectionState = {
    sections: [],
    hasAllSectionsOpen: false,
};

const actions = {
    "Toolkit/Components/Styleguide/CreateStyleguideSection": (
        draft: Draft<StyleguideSectionState>,
        action: { section: StyleguideSectionModel; sections: StyleguideSectionModel[] },
    ) => {
        const hasClosedSections = action.sections.some(x => !x.isOpen);
        const hasOpenedSections = action.sections.some(x => x.isOpen);

        draft.sections = [...draft.sections, action.section];
        draft.hasAllSectionsOpen = hasClosedSections && hasOpenedSections ? "mixed" : !hasClosedSections;
    },
    "Toolkit/Components/Styleguide/SetIsStyleguideSectionOpen": (
        draft: Draft<StyleguideSectionState>,
        action: { sections: StyleguideSectionModel[] },
    ) => {
        const hasClosedSections = action.sections.some(x => !x.isOpen);
        const hasOpenedSections = action.sections.some(x => x.isOpen);

        draft.sections = action.sections;
        draft.hasAllSectionsOpen = hasClosedSections && hasOpenedSections ? "mixed" : !hasClosedSections;
    },
    "Toolkit/Components/Styleguide/RemoveStyleguideSection": (
        draft: Draft<StyleguideSectionState>,
        action: { id: string; sections: StyleguideSectionModel[] },
    ) => {
        const hasClosedSections = action.sections.some(x => !x.isOpen);
        const hasOpenedSections = action.sections.some(x => x.isOpen);

        draft.sections = draft.sections.filter(x => x.id !== action.id);
        draft.hasAllSectionsOpen = hasClosedSections && hasOpenedSections ? "mixed" : !hasClosedSections;
    },
    "Toolkit/Components/Styleguide/OpenAllStyleguideSections": (
        draft: Draft<StyleguideSectionState>,
        action: { isOpen: boolean; sections: StyleguideSectionModel[] },
    ) => {
        draft.sections = action.sections;
        draft.hasAllSectionsOpen = action.isOpen;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StyleguideActions = Parameters<typeof reducer>[1];
export default reducer;
